import ProcessList from './ProcessList'

const ProcessListAllOngoing = () => {
  return <ProcessList endpoint={'Processes/UsersOngoing/'} process={"ongoing"} />
}

export default ProcessListAllOngoing